import { render, staticRenderFns } from "./AccessDenied.vue?vue&type=template&id=028f361b&scoped=true&"
var script = {}
import style0 from "./AccessDenied.vue?vue&type=style&index=0&id=028f361b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028f361b",
  null
  
)

export default component.exports